import { SegmentsRepository } from "../../repository/api/segment/segment";
import { actionCreators } from "../../state";
import {ChannelCreateChannelRequest as SegmentCreateSegmentRequest} from "../../repository/api/generated";

export class SegmentUseCases {
    private api: SegmentsRepository;
    private stateActions: typeof actionCreators;

    constructor(api: SegmentsRepository, stateActions: typeof actionCreators) {
        this.api = api;
        this.stateActions = stateActions;
    }

    // public SegmentsListWithCountOfLeadsByDate = async (date: Date, projectName: string, offset: number, limit: number) => {
    //     this.stateActions.SendSegmentListRequest()
    //     let response = await this.api.SegmentsListWithCountOfLeadsByDate(date, projectName, offset, limit)
    //     if (response instanceof Error) {
    //         this.stateActions.SegmentListError(response.message)
    //         return
    //     } else {
    //         this.stateActions.SegmentListSuccess(response.segments, response.count)
    //     }
    // }
    public SegmentsList = async (offset: number | undefined,
                                 limit: number | undefined,
                                 isActive: boolean | undefined) => {
        this.stateActions.SendSegmentListRequest()
        let response = await this.api.SegmentsList(offset, limit, isActive)
        if (response instanceof Error) {
            this.stateActions.SegmentListError(response.message)
            return
        } else {
            this.stateActions.SegmentListSuccess(response.segments, response.count)
        }
    }

    public CreateSegment = async (body:  SegmentCreateSegmentRequest, callback: () => void) => {
        this.stateActions.SegmentCreateRequest()
        let response = await this.api.CreateSegment(body)
        if (response instanceof Error) {
            this.stateActions.SegmentCreateError(response.message)
            return
        } else {
            this.stateActions.SegmentCreateSuccess(response)
            callback()
        }
    }

    public UpdateSegmentIntegration = async (id: string, leadType: string, pipelineId: number, statusId: number, cityId: number, tag: string, utmSource: string,  isActive: boolean, autoId: number, homeJkId: number, projectName: string,callback: () => void) => {
        this.stateActions.SegmentCreateRequest()
        let response = await this.api.UpdateSegmentIntegration(id, leadType, pipelineId, statusId, cityId, tag, utmSource, isActive, autoId, homeJkId, projectName)
        if (response instanceof Error) {
            this.stateActions.SegmentUpdateError(response.message)
            return
        } else {
            this.stateActions.SegmentUpdateSuccess(response)
            callback()
        }
    }

    // public UpdateSegmentExportToTz = async (id: string, firstComment: string, secondComment: string, domainsList: string[], phonesList: string[], alphaList: string[], depth: number, geoRegion: string[], minAge: number, maxAge: number, triggersMinCount: number, limits: number, callback: () => void) => {
    //     this.stateActions.SegmentCreateRequest()
    //     let response = await this.api.UpdateSegmentExportToTz(id, firstComment, secondComment, domainsList, phonesList, alphaList, depth, geoRegion, minAge, maxAge, triggersMinCount, limits)
    //     if (response instanceof Error) {
    //         this.stateActions.SegmentCreateError(response.message)
    //         return
    //     } else {
    //         this.stateActions.SegmentCreateSuccess(response)
    //         callback()
    //     }
    // }

    public DeleteSegment = async (id: UniqueId) => {
        this.stateActions.SegmentDeleteRequest()
        let response = await this.api.DeleteSegment(id)
        if (response instanceof Error) {
            this.stateActions.SegmentDeleteError(response.message)
            return
        } else {
            this.stateActions.SegmentDeleteSuccess(id)
        }
    }

    // public ToggleSegmentExportToTzActivity = async (id: UniqueId, enabled: boolean) => {
    //     let response = await this.api.ToggleSegmentExportToTzActivity(id, enabled)
    //     return response
    // }

    public ReadSegmentById = async (id: UniqueId) => {
        let response = await this.api.ReadSegmentById(id)
        return response
    }

    // public ToggleSegmentIntegrationActivity = async (id: UniqueId, enabled: boolean) => {
    //     let response = await this.api.ToggleSegmentIntegrationActivity(id, enabled)
    //     return response
    // }

}
